import { PaperVSOrganizationInsert, PaperVSOrganizationInsertMany, PaperVSOrganizationDelete, PaperVSOrganizationUpdate, PaperVSOrganizationGetById, PaperVSOrganizationGetList, PaperVSOrganizationGetPageList } from "@/api/papervsorganization/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    PaperVSOrganizationInsert(context, payload) {
        return new Promise((resolve, reject) => {
            PaperVSOrganizationInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    PaperVSOrganizationInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            PaperVSOrganizationInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    PaperVSOrganizationUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperVSOrganizationUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    PaperVSOrganizationGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperVSOrganizationGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    PaperVSOrganizationGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperVSOrganizationGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    PaperVSOrganizationGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperVSOrganizationGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}